import styled from 'styled-components';

// Reminder Common UI Dialog box heigh is 0.75 * window.innerHeight
const height = 0.71 * window.innerHeight;

export const FormBody = styled.div<{
  printView?: boolean;
  dialogHeight?: boolean;
}>`
  color: ${(props: any) => props.theme.palette.text.primary};
  ${(props: any) =>
    props.printView
      ? `margin-bottom: 20px;`
      : `
  background-color: ${props.theme.palette.background.paper};
  width: 100%;
  // height: 100%;
  overflow-y: scroll;`}
  ${(props: any) =>
    props.dialogHeight
      ? `height: ${height}px;
         padding-left: 2%;`
      : `;`}
  @media print {
    color: black;
  }
`;

export const Text = styled.div`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
`;

export const DCSegment = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  ${(props: any) => {
    const { secondary } = props.theme.palette.text;
    const { paper } = props.theme.palette.background;
    return `color: ${paper};
    background-color: ${secondary};
      display: flex;
      &:before {
    content: '• ';
    color: ${secondary};
  }`;
  }}
  @media print {
    color: black;
    background-color: white;
  }
`;
export const DCDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;
// comment noBullet not used
export const StyledLi = styled.li<{
  dc?: boolean;
  horizontal?: boolean;
  noBullet?: boolean;
}>`
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
  ${(props: any) => {
    const { secondary } = props.theme.palette.text;
    return props.dc
      ? `color: ${secondary};
      display: flex;
      &:before {
    content: '• ';
    color: ${secondary};
  }`
      : `color: ${secondary};
      &:before {
    content: '• ';
    color: ${secondary};
  }`;
  }}
  ${(props: any) => {
    const { secondary } = props.theme.palette.text;
    return props.noBullet
      ? `color: ${secondary};
      &:before {
    content: '';
    color: ${secondary};
  }`
      : ';';
  }}
  padding: 3px;
  @media print {
    color: black;
    &:before {
      color: black;
    }
`;
export const StyledDiv = styled.div<{
  dc?: boolean;
  horizontal?: boolean;
}>`
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
  ${(props: any) => {
    const { secondary } = props.theme.palette.text;
    const { paper } = props.theme.palette.background;
    return props.dc
      ? `color: ${paper};
      background-color: ${secondary};
      display: flex;`
      : `color: ${secondary};`;
  }}
  align-items: center;
  padding: 3px;
  white-space: pre-line;
  @media print {
    color: black;
  }
`;

export const InputDiv = styled.div`
  padding: 3px;
`;

export const FormLi = styled.li<{
  horizontal?: boolean;
}>`
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
  width: 100%
`;
export const FullWidthLi = styled.li`
  width: 100%;
`;
export const StyledUl = styled.ul<{
  horizontal?: boolean;
}>`
  list-style-type: none;
  padding-inline-start: 5px;
  ${(props: any) => (props.horizontal ? `display: flex; flex-wrap: wrap` : `;`)}
`;
export const StyledReadOnlyUl = styled.ul<{
  horizontal?: boolean;
}>`
  list-style-type: none;
  padding-inline-start: 5px;
  ${(props: any) => (props.horizontal ? `display: flex;` : `;`)}
`;

export const ElementDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const EffDateDiv = styled.div`
  width: 200px;
  padding-bottom: 15px;
`;

export const OtherInputDiv = styled.div`
  display: block;
`;
// ScrollToTarget PreviewForm Functionality
export const PreviewFormDiv = styled.div`
  height: auto;
  overflow: auto;
  overscroll-behavior: contain;
`;
export const PreviewFormTop = styled.div`
  margin-bottom: 55px;
`;
export const NoCPPText = styled.div`
  @media print {
    color: black;
  }
  ${(props: any) => {
    const { secondary } = props.theme.palette.text;
    return `color: ${secondary};`;
  }}
  padding: 10px;
  @media print {
    color: black;
  }
`;
export const SavingDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(129, 199, 132, 0.5);
  color: white;
  min-height: 30px;
  height: 80%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-border-radius: 4px;
`;

export const TitleOtherCpp = styled.div`
  margin-bottom: 20px;
`;
